import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import * as styles from './TgbTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TgbTemplate = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TgbTemplate, _React$PureComponent);
  var _super = _createSuper(TgbTemplate);
  function TgbTemplate() {
    _classCallCheck(this, TgbTemplate);
    return _super.apply(this, arguments);
  }
  _createClass(TgbTemplate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        image = _this$props.image,
        title = _this$props.title,
        description = _this$props.description,
        phone = _this$props.phone,
        footnote = _this$props.footnote,
        url = _this$props.url;
      return /*#__PURE__*/_jsxs("a", {
        href: url,
        target: "_blank",
        rel: "noreferrer noopener nofollow",
        className: styles['container'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['image'],
          children: /*#__PURE__*/_jsx("img", {
            src: image,
            alt: title
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['aside'],
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles['title'],
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: styles['text'],
            children: description
          }), phone && /*#__PURE__*/_jsx("div", {
            className: styles['phone'],
            children: phone
          })]
        }), footnote && /*#__PURE__*/_jsx("div", {
          className: styles['note'],
          children: footnote
        })]
      });
    }
  }]);
  return TgbTemplate;
}(React.PureComponent);